import { KeyValuePipe } from '@angular/common';
import { Component, Input, output } from '@angular/core';
import { IPaytrailData } from '../../interfaces';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CardModule} from 'primeng/card';

@Component({
    selector: 'app-paytrail-payment-form',
    imports: [AccordionModule, CardModule, ButtonModule],
    templateUrl: './paytrail-payment-form.component.html',
    styleUrl: './paytrail-payment-form.component.scss'
})
export class PaytrailPaymentFormComponent {
  @Input() paymentFormData:IPaytrailData;
  
  onPaymentSelected = output<string>();

  selectedPaymentOption:string|null|undefined = null;

  selectPaymentOption(group:string, id:string|undefined, text:string, logoUrl:string) {
    this.selectedPaymentOption = group+"|"+id+"|"+text+"|"+logoUrl;
    this.onPaymentSelected.emit(this.selectedPaymentOption);
  }
}
